import type {
  ComplaintInvestigation,
  DustControlInspection,
  DustInspection,
  Inspection,
  VacantLandInspection,
  VacantLandSpecificInspection,
} from "./inspection";

export const combineSeperatedDustControlFields = (data: DustInspection | ComplaintInvestigation) => {
  if (!data.dustControlInspection) data.dustControlInspection = {} as DustControlInspection;
  if (data.dustControlInspection_0) {
    //dustControlInspection_0
    data.dustControlInspection.additionalInstructionsOtherNoncomplianceItems =
      data.dustControlInspection_0.additionalInstructionsOtherNoncomplianceItems;
  }
  if (data.dustControlInspection_1) {
    //dustControlInspection_1
    data.dustControlInspection.weatherMurn = data.dustControlInspection_1.weatherMurn;
    data.dustControlInspection.weather = data.dustControlInspection_1.weather;
    data.dustControlInspection.isRain = data.dustControlInspection_1.isRain;
    data.dustControlInspection.temperature = data.dustControlInspection_1.temperature;
    data.dustControlInspection.windSpeedMurn = data.dustControlInspection_1.windSpeedMurn;
    data.dustControlInspection.windGustMurn = data.dustControlInspection_1.windGustMurn;
    data.dustControlInspection.windDirectionMurn = data.dustControlInspection_1.windDirectionMurn;
    data.dustControlInspection.siteStatusMurn = data.dustControlInspection_1.siteStatusMurn;
    data.dustControlInspection.windSpeed = data.dustControlInspection_1.windSpeed;
    data.dustControlInspection.windGust = data.dustControlInspection_1.windGust;
    data.dustControlInspection.windDirection = data.dustControlInspection_1.windDirection;
    data.dustControlInspection.siteStatus = data.dustControlInspection_1.siteStatus;
    data.dustControlInspection.isPcfSubmitted = data.dustControlInspection_1.isPcfSubmitted;
    data.dustControlInspection.areWorkersPresent = data.dustControlInspection_1.areWorkersPresent;
    data.dustControlInspection.spokeWithName1 = data.dustControlInspection_1.spokeWithName1;
    data.dustControlInspection.spokeWithTitle1Murn = data.dustControlInspection_1.spokeWithTitle1Murn;
    data.dustControlInspection.spokeWithMethod1Murn = data.dustControlInspection_1.spokeWithMethod1Murn;
    data.dustControlInspection.spokeWithTitle1 = data.dustControlInspection_1.spokeWithTitle1;
    data.dustControlInspection.spokeWithMethod1 = data.dustControlInspection_1.spokeWithMethod1;
    data.dustControlInspection.spokeWithName2 = data.dustControlInspection_1.spokeWithName2;
    data.dustControlInspection.spokeWithTitle2Murn = data.dustControlInspection_1.spokeWithTitle2Murn;
    data.dustControlInspection.spokeWithMethod2Murn = data.dustControlInspection_1.spokeWithMethod2Murn;
    data.dustControlInspection.spokeWithTitle2 = data.dustControlInspection_1.spokeWithTitle2;
    data.dustControlInspection.spokeWithMethod2 = data.dustControlInspection_1.spokeWithMethod2;
  }
  if (data.dustControlInspection_2) {
    //dustControlInspection_2
    data.dustControlInspection.isProjectCompliant = data.dustControlInspection_2.isProjectCompliant;
  }
  if (data.dustControlInspection_3) {
    //dustControlInspection_3
    data.dustControlInspection.violationIn1000FtOfMurn = data.dustControlInspection_3.violationIn1000FtOfMurn;
  }
  if (data.dustControlInspection_4) {
    //dustControlInspection_4
    data.dustControlInspection.violationIn1000FtOf = data.dustControlInspection_4.violationIn1000FtOf;
    data.dustControlInspection.isEmissionCompliant = data.dustControlInspection_4.isEmissionCompliant;
    data.dustControlInspection.fugitiveDustSourceMurn = data.dustControlInspection_4.fugitiveDustSourceMurn;
    data.dustControlInspection.fugitiveDustSource = data.dustControlInspection_4.fugitiveDustSource;
    data.dustControlInspection.otherSource = data.dustControlInspection_4.otherSource;
    data.dustControlInspection.plumeLength = data.dustControlInspection_4.plumeLength;
    data.dustControlInspection.measurementUnitsMurn = data.dustControlInspection_4.measurementUnitsMurn;
    data.dustControlInspection.measurementUnits = data.dustControlInspection_4.measurementUnits;
    data.dustControlInspection.opacity = data.dustControlInspection_4.opacity;
    data.dustControlInspection.opacityTestMethodMurn = data.dustControlInspection_4.opacityTestMethodMurn;
    data.dustControlInspection.opacityTestMethod = data.dustControlInspection_4.opacityTestMethod;
    data.dustControlInspection.isBmpCompliant = data.dustControlInspection_4.isBmpCompliant;
    data.dustControlInspection.projectSoilsMurn = data.dustControlInspection_4.projectSoilsMurn;
    data.dustControlInspection.projectSoils = data.dustControlInspection_4.projectSoils;
    data.dustControlInspection.sizeOfInstability = data.dustControlInspection_4.sizeOfInstability;
    data.dustControlInspection.trackoutDeviceMurn = data.dustControlInspection_4.trackoutDeviceMurn;
    data.dustControlInspection.trackoutDevice = data.dustControlInspection_4.trackoutDevice;
    data.dustControlInspection.hasTrackout = data.dustControlInspection_4.hasTrackout;
    data.dustControlInspection.trackoutLength = data.dustControlInspection_4.trackoutLength;
    data.dustControlInspection.trackoutLocation = data.dustControlInspection_4.trackoutLocation;
    data.dustControlInspection.trackoutRemediateByMurn = data.dustControlInspection_4.trackoutRemediateByMurn;
    data.dustControlInspection.mitigationEquipmentMurn = data.dustControlInspection_4.mitigationEquipmentMurn;
    data.dustControlInspection.soilCrustDeterminationMurn = data.dustControlInspection_4.soilCrustDeterminationMurn;
    data.dustControlInspection.trackoutRemediateBy = data.dustControlInspection_4.trackoutRemediateBy;
    data.dustControlInspection.mitigationEquipment = data.dustControlInspection_4.mitigationEquipment;
    data.dustControlInspection.soilCrustDetermination = data.dustControlInspection_4.soilCrustDetermination;
    data.dustControlInspection.isAdminCompliant = data.dustControlInspection_4.isAdminCompliant;
    data.dustControlInspection.acreagePermitted = data.dustControlInspection_4.acreagePermitted;
    data.dustControlInspection.observedAcreage = data.dustControlInspection_4.observedAcreage;
    data.dustControlInspection.projectSizeMurn = data.dustControlInspection_4.projectSizeMurn;
    data.dustControlInspection.projectSize = data.dustControlInspection_4.projectSize;
    data.dustControlInspection.submitPermitModificationApplicationByDate =
      data.dustControlInspection_4.submitPermitModificationApplicationByDate;
    data.dustControlInspection.complyWithProjectLimitsBeforeDate =
      data.dustControlInspection_4.complyWithProjectLimitsBeforeDate;
    data.dustControlInspection.stagingParkingAreaMurn = data.dustControlInspection_4.stagingParkingAreaMurn;
    data.dustControlInspection.stagingParkingArea = data.dustControlInspection_4.stagingParkingArea;
    data.dustControlInspection.hasValidDustPermit = data.dustControlInspection_4.hasValidDustPermit;
    data.dustControlInspection.submitDcopApplicationByDate = data.dustControlInspection_4.submitDcopApplicationByDate;
    data.dustControlInspection.dcopSignMurn = data.dustControlInspection_4.dcopSignMurn;
    data.dustControlInspection.dcopSign = data.dustControlInspection_4.dcopSign;
    data.dustControlInspection.dcopOnSiteMurn = data.dustControlInspection_4.dcopOnSiteMurn;
    data.dustControlInspection.dcopOnSite = data.dustControlInspection_4.dcopOnSite;
    data.dustControlInspection.resolveSignageIssuesBeforeDate =
      data.dustControlInspection_4.resolveSignageIssuesBeforeDate;
    data.dustControlInspection.ssPermitsMurn = data.dustControlInspection_4.ssPermitsMurn;
    data.dustControlInspection.ssPermits = data.dustControlInspection_4.ssPermits;
    data.dustControlInspection.ssPermitNumber = data.dustControlInspection_4.ssPermitNumber;
    data.dustControlInspection.actualEquipmentOnsiteDate = data.dustControlInspection_4.actualEquipmentOnsiteDate;
  }
};

export const combineSeperatedVacantLandFields = (data: VacantLandInspection | ComplaintInvestigation) => {
  if (!data.vacantLandInspection) data.vacantLandInspection = {} as VacantLandSpecificInspection;
  if (data.vacantLandInspection_0) {
    //_0
    data.vacantLandInspection.locationDescription = data.vacantLandInspection_0.locationDescription;
    data.vacantLandInspection.ownerName = data.vacantLandInspection_0.ownerName;
    data.vacantLandInspection.regionMurn = data.vacantLandInspection_0.regionMurn;
    data.vacantLandInspection.mailAddress = data.vacantLandInspection_0.mailAddress;
  }
  if (data.vacantLandInspection_1) {
    //_01
    data.vacantLandInspection.sectionMurn = data.vacantLandInspection_1.sectionMurn;
    data.vacantLandInspection.section = data.vacantLandInspection_1.section;
  }
  if (data.vacantLandInspection_2) {
    // _02
    data.vacantLandInspection.currentLandUseAgreement = data.vacantLandInspection_2.currentLandUseAgreement;
    data.vacantLandInspection.soilConditionMurn = data.vacantLandInspection_2.soilConditionMurn;
    data.vacantLandInspection.soilCondition = data.vacantLandInspection_2.soilCondition;
    data.vacantLandInspection.soilNote = data.vacantLandInspection_2.soilNote;
    data.vacantLandInspection.disturbanceFactorMurns = data.vacantLandInspection_2.disturbanceFactorMurns;
    data.vacantLandInspection.disturbanceFactors = data.vacantLandInspection_2.disturbanceFactors;
    data.vacantLandInspection.otherDisturbanceFactors = data.vacantLandInspection_2.otherDisturbanceFactors;
    data.vacantLandInspection.fugitiveDustObserved = data.vacantLandInspection_2.fugitiveDustObserved;
    data.vacantLandInspection.dustGeneratedBy = data.vacantLandInspection_2.dustGeneratedBy;
    data.vacantLandInspection.controlMeasuresImplemented = data.vacantLandInspection_2.controlMeasuresImplemented;
    data.vacantLandInspection.measureImplementedMurns = data.vacantLandInspection_2.measureImplementedMurns;
    data.vacantLandInspection.measureImplementeds = data.vacantLandInspection_2.measureImplementeds;
    data.vacantLandInspection.otherMeasuresImplemented = data.vacantLandInspection_2.otherMeasuresImplemented;
    data.vacantLandInspection.dropBallTest = data.vacantLandInspection_2.dropBallTest;
    data.vacantLandInspection.areaOne = data.vacantLandInspection_2.areaOne;
    data.vacantLandInspection.areaTwo = data.vacantLandInspection_2.areaTwo;
    data.vacantLandInspection.areaThree = data.vacantLandInspection_2.areaThree;
    data.vacantLandInspection.rockTest = data.vacantLandInspection_2.rockTest;
    data.vacantLandInspection.rockTestPercent = data.vacantLandInspection_2.rockTestPercent;
    data.vacantLandInspection.siltContentTest = data.vacantLandInspection_2.siltContentTest;
    data.vacantLandInspection.siltContentPercent = data.vacantLandInspection_2.siltContentPercent;
    data.vacantLandInspection.opacityTest = data.vacantLandInspection_2.opacityTest;
    data.vacantLandInspection.opacityPercent = data.vacantLandInspection_2.opacityPercent;
    data.vacantLandInspection.hasPhotography = data.vacantLandInspection_2.hasPhotography;
    data.vacantLandInspection.trafficCount = data.vacantLandInspection_2.trafficCount;
  }
};

export const removeExtraVLInspectionFields = (data: VacantLandInspection | ComplaintInvestigation) => {
  delete data.vacantLandInspection_0;
  delete data.vacantLandInspection_1;
  delete data.vacantLandInspection_2;
};

export const removeExtraDustInspectionFields = (data: DustInspection | ComplaintInvestigation) => {
  delete data.dustControlInspection_0;
  delete data.dustControlInspection_1;
  delete data.dustControlInspection_2;
  delete data.dustControlInspection_3;
  delete data.dustControlInspection_4;
};
